// extracted by mini-css-extract-plugin
export default {"root":"_32m08","item":"GSnag"};